import React, { useLayoutEffect, useRef } from "react";

// A table that turns into one card per row on phones. Each cell gets its column heading as data-label,
// which the phone CSS shows next to the value (admin.css: ".rtable"). Cells spanning several columns
// (empty / loading rows) are left without a label.
export default function DataTable({ className = "site-table", wrapClassName = "site-table-wrap", children }) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const table = ref.current;
    if (!table) return;
    const headings = [...table.querySelectorAll("thead th")].map((th) => th.textContent.trim());
    table.querySelectorAll("tbody tr").forEach((row) => {
      [...row.children].forEach((cell, index) => {
        cell.setAttribute("data-label", cell.colSpan > 1 ? "" : headings[index] || "");
      });
    });
  });

  return (
    <div className={wrapClassName}>
      <table ref={ref} className={`${className} rtable`}>{children}</table>
    </div>
  );
}
